var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIcloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.547,
    height: 40.547
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "social-icloud_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 22749",
    d: "M17.8 9.156a4.745 4.745 0 014.036-4.676A4.3 4.3 0 0117.8 9.156zm5.1 6.317a4.126 4.126 0 002.874 3.921v.044a12.136 12.136 0 01-3.138 4.619c-1.132 1.2-2.785.056-2.785.056-1.308-.927-3.311-.028-3.311-.028a2.017 2.017 0 01-2.641-.028c-1.714-1.248-3.211-4.816-3.211-4.816-2.147-6.678 2.207-8.857 2.207-8.857 2.119-1.425 5.025.582 5.025.582 5.053-3.054 7.268.674 7.34.8a4.122 4.122 0 00-2.36 3.7z",
    transform: "translate(-10.087 -4.48)",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2003",
    d: "M0 0h40.547v40.547H0z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.906 8.923)",
    clipPath: "url(#social-icloud_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 2712",
    fill: "#a8a9ba",
    d: "M-2.006-2.007h19.71v24.132h-19.71z"
  }))));
}
export default SvgSocialIcloud;